import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Base, StoreIcon } from '@itsrever/design-system'
import { useAppSelector } from '@/redux/hooks'
import { seesEveryGroup } from '@/domain/store-group'

// Staff have no own group: with nothing picked these APIs refuse them or use the first store.
export const PickScope = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation()
  const user = useAppSelector((s) => s.userApi.getMe.response.user)
  const selectedEcommerce = useAppSelector(
    (s) => s.generalData.selectedEcommerce
  )
  const selectedGroup = useAppSelector((s) => s.generalData.selectedGroup)

  if (!seesEveryGroup(user) || selectedEcommerce || selectedGroup)
    return <>{children}</>
  return (
    <div className="flex justify-center px-8 py-16">
      <Base.EmptyState
        variant="card"
        className="max-w-md"
        icon={<StoreIcon />}
        title={t('selector_component.pick_scope_title')}
        description={t('selector_component.pick_scope_description')}
      />
    </div>
  )
}
